<template>
  <page-header></page-header>
  <div
    class="modal fade parcel_number"
    id="exampleModal1"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    style="display: none"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content text-center rounded-0">
        <div class="modal-header border-0">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="closeModalErrorWindow()"
          ></button>
        </div>
        <div class="modal-body">
          <h2>Numéro de colis</h2>
          <p class="parcel_number-value">2234234</p>
          <div class="information-parcel text-start">
            <p class="fw-bold text-start">
              Nous n'avons pas d'informations pour le colis que vous avez saisi
              pour l'une des raisons suivantes :
            </p>
            <ul class="parcel_list text-start">
              <li>
                L'identifiant du colis que vous avez saisi est incorrect.
                Veuillez le revoir et réessayer.
              </li>
              <li>
                Le code postal que vous avez entré est incorrect. Veuillez
                l'examiner et essayer à nouveau.
              </li>
              <li>
                Nous n'avons pas encore reçu d'informations de l'expéditeur pour
                cet article.
              </li>
            </ul>
            <p>
              Ces résultats reflètent les mises à jour les plus récentes de
              notre système. Nos représentants du service à la clientèle ont
              accès aux mêmes informations que celles présentées ici et ne sont
              pas en mesure de fournir plus de détails pour le moment.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="innerBanner trackShipBanner position-relative">
    <div class="inBannerTrackingImg">
      <img
        src="../../assets/trackShipment-banner.jpg"
        alt="Track your shipment"
      />
    </div>
    <div class="container-sm">
      <div class="col-lg-6 col-md-6">
        <div class="innerBannerText">
          <h1 class="text-uppercase">Suivez votre envoi</h1>
        </div>
        <div class="parcel-number position-relative pe-5">
          <div class="mb-3 data-input">
            <br />
            <label for="exampleFormControlInput1" class="form-label"
              >Informations sur le colis:</label
            >
            <span class="red-star">*</span>

            <div class="input-group">
              <input
                type="text"
                name="bniTrackingID"
                class="form-control rounded-0 bniParcelID"
                id="exampleFormControlInput1"
                placeholder="Entrez votre numéro de colis"
                v-model="tracking_id"
                required
              />
              <br />
            </div>
            <br />
            <div class="input-group">
              <input
                type="text"
                name="bniPostalCode"
                class="form-control rounded-0 bniPostalCode"
                id="exampleFormControlInput1"
                placeholder="Entrez votre code postal"
                v-model="postal_code"
                required
              />
            </div>
            <br />
            <button
              name="submit"
              @click="queryForParcelData()"
              class="btn btn-primary text-uppercase submit_button"
            >
              Soumettre
            </button>
            <p class="py-2 need-support">
              Besoin d'aide ?
              <a href="#/fr/support">Cliquez ici</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="order-details-box position-relative">
    <div class="container-sm">
      <h2 class="sub_heading">Détails de la commande</h2>
      <div class="row g-2 mb-3">
        <div class="col-lg-3 col-md-3 delivery-car text-center">
          <img src="../../assets/realtimeIcon.png" alt="" class="img-fluid" />
        </div>
        <div class="col-lg-3 col-md-5">
          <h3
            class="deliver-sub_heading text-uppercase text-black bg-warning p-2 px-4 text-center"
          >
            Identifiant du paquet
          </h3>
          <p class="packaged-id-pehra text-center package-id"></p>
        </div>
        <!--                 <div class="col-lg-2 col-md-6">
                        <h3 class="deliver-sub_heading text-uppercase text-black bg-warning p-2 px-4 text-center">Shipper</h3>
                        <p class="packaged-id-pehra text-center"></p>
                    </div> -->
        <div class="col-lg-3 col-md-5">
          <h3
            class="deliver-sub_heading text-uppercase text-black bg-warning p-2 px-4 text-center"
          >
            Date de la commande
          </h3>
          <p class="packaged-id-pehra text-center order-date"></p>
        </div>
        <div class="col-lg-3 col-md-6">
          <h3
            class="deliver-sub_heading text-uppercase text-black bg-warning p-2 px-4 text-center"
          >
            Livraison attendue
          </h3>
          <p class="packaged-id-pehra text-center expected-delivery"></p>
        </div>
      </div>
      <div class="row g-2">
        <div class="col-lg-3 col-md-3 delivered-box text-center">
          <img src="../../assets/proofIcon.png" alt="" class="img-fluid" />
        </div>
        <div class="col-lg-8 col-md-8">
          <h3
            class="deliver-sub_heading text-uppercase text-black bg-warning p-2 px-4 text-center"
          >
            Situation actuelle
          </h3>

          <p class="packaged-id-pehra text-center current-status"></p>
        <div id="pickupDetails" style="">
          <div class="mb-3">
            <p class="pickup_location"></p>
            <p class="pickup_description"></p>
          </div>
        </div>

        </div>

        <p class="need-support float-end">
          Besoin d'aide ? <a href="#/fr/support">Cliquez ici</a>
        </p>
      </div>
    </div>

    <div class="parcel-tracking-details position-relative">
      <div class="container-sm">
        <div class="mb-3">
          <h2 class="sub_heading">Détails du suivi des colis</h2>
        </div>
        <div class="row g-2">
          <div class="col-lg-3 col-md-3 delivered-box text-center">
            <img
              src="../../assets/task_todo_icon.png"
              alt=""
              class="img-fluid"
            />
          </div>
          <div class="col-lg-9 col-md-9">
            <table class="table trackingTable">
              <thead>
                <tr>
                  <th scope="col">Date</th>
                  <th scope="col" style="width: 20%">Ville</th>
                  <th scope="col" style="width: 7%">Province</th>
                  <th scope="col">Statut du colis</th>
                </tr>
              </thead>
              <tbody class="trackingTableBody">
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <!--                 <h2 class="proof_heading text-black position-relative mt-2"><img src="#" alt="bullet" class="img-fluid"> Proof of Delivery, review the delivery image</h2> -->
            <!-- 				<button type="button" class="proof_heading text-black position-relative mt-2 border-0 bg-white" data-bs-toggle="modal" data-bs-target="#staticBackdrop"><img src="https://postmediaparcelservices.com/wp-content/themes/bniparcel/images/map-bullets.png" alt="bullet" class="img-fluid"> Proof of Delivery, review the delivery image 
                    </button> -->
          </div>
        </div>

        <!--         <div class="tracking_map-section position-absolute top-0 end-0">
                <img src="https://postmediaparcelservices.com/wp-content/themes/bniparcel/images/tracking_map.jpg" alt="map" class="img-fluid">
            </div> -->
      </div>
      <div class="times hide" style="display: block">
        <div class="mb-3">
          <p class="timesDisplayed">Toutes les heures sont affichées en GMT</p>
        </div>
      </div>

    </div>
  </div>

  <page-footer></page-footer>
</template>

<script>
import PageFooter from "../fr/PageFooter.vue";
import PageHeader from "../fr/PageHeader.vue";
import axios from "axios";
import { parcel_api } from '@/js_utils/urls.js'

export default {
  mounted() {
    let uri = window.location.search.substring(1);
     let params = new URLSearchParams(uri);
     if (params.size != 0) {
       this.tracking_id = params.get("bniTrackingID");
       this.postal_code = params.get("bniPostalCode");

       this.queryForParcelData();
     }
    if (sessionStorage.getItem("data") != undefined) {

      let res = JSON.parse(sessionStorage.getItem("data"));
      sessionStorage.clear();
      this.displayData(res);
    }
  },
  methods: {
    showParcelData(data) {
      let city = data["shipping_city"];
      let country = data["shipping_country"];
      let postal = data["shipping_postal_code"];
      let province = data["shipping_state"];
      let street = data["shipping_street"];
      let description = data["description"].replace(/\n/g, "<br />");
      document.querySelector(".pickup_location").innerHTML =
        "<b>Disponible pour le ramassage à: </b>" +
        street +
        ", " +
        city +
        ", " +
        province +
        ", " +
        country +
        ", " +
        postal;
      document.querySelector(".pickup_description").innerHTML =
        "<b>Description: </b><br />" + description ;
    },
    displayData(res) {
      let submit_button = document.querySelector(".submit_button");
      let tableData = "";
      document.querySelector(".pickup_location").innerHTML = "";

      if (res["data"]["statuses"] == undefined) {
        document.querySelector(".parcel_number").classList.add("show");
        document.querySelector(".parcel_number").style.display = "block";
        document.querySelector(".parcel_number").ariaModal = true;
        document.querySelector(".parcel_number-value").innerHTML =
          this.tracking_id;
      } else {
        let status_arr = res["data"]["statuses"];

        status_arr.sort(function (a, b) {
          return new Date(b.event_date_time) - new Date(a.event_date_time);
        });

        let latest_date;
        let latest_status;

        let available = false;
        let pickup_info;

        for (let i = 0; i < status_arr.length; i++) {
          let current_status = status_arr[i];
          let local_date_time = current_status["event_date_time"];
          let parcel_status_message = current_status["parcel_status_message_french"];
          if(parcel_status_message == "null") {
            parcel_status_message = "N/A"
          }

          if (latest_date == undefined) {
            latest_date = current_status["event_date_time"];
            latest_status = parcel_status_message;
          } else if (
            new Date(latest_date) < new Date(current_status["event_date_time"])
          ) {
            latest_date = current_status["event_date_time"];
            latest_status = parcel_status_message;
          }
          tableData +=
            "<tr><td>" +
            local_date_time +
            "</td><td>" +
            current_status["event_city"] +
            "</td><td>" +
            current_status["event_province"] +
            "</td><td>";

          if (
            current_status["parcel_status_message_french"] == "Disponible pour ramassage"
          ) {
            tableData += "<a>" + parcel_status_message + "</a></td></tr>";
            available = true;
            pickup_info = current_status["pickup_information"];
          } else {
            tableData += parcel_status_message + "</td></tr>";
          }
        }

        document.querySelector(".times").classList.remove("hide");

        if (available) {
          this.showParcelData(pickup_info);
        }
        document.querySelector(".trackingTableBody").innerHTML = tableData;
        document.querySelector(".expected-delivery").innerHTML =
          res["data"]["expected_delivery_date"];
        document.querySelector(".order-date").innerHTML =
          res["data"]["parcel_ordered_date"];
        document.querySelector(".current-status").innerHTML = latest_status;
        document.querySelector(".package-id").innerHTML =
          res["data"]["tracking_id"];

        submit_button.innerHTML = "Submit";
        submit_button.blur();
        submit_button.disabled = false;

        document.querySelector(".order-details-box").scrollIntoView();
      }
    },
    /* eslint-disable */
    queryForParcelData() {
      this.postal_code = this.postal_code.trim().toUpperCase();
      this.tracking_id = this.tracking_id.trim().toUpperCase();
      let submit_button = document.querySelector(".submit_button");
      submit_button.disabled = true;

      if (this.tracking_id.trim() == "" || this.postal_code.trim() == "") {
        document.querySelector(".parcel_number").classList.add("show");
        document.querySelector(".parcel_number").style.display = "block";
        document.querySelector(".parcel_number").ariaModal = true;
        document.querySelector(".parcel_number-value").innerHTML =
          this.tracking_id;
        submit_button.blur();
        submit_button.disabled = false;
      } else {
        if (this.postal_code.length == 6) {
          let first_half = this.postal_code.slice(
            0,
            this.postal_code.length / 2
          );
          let second_half = this.postal_code.slice(
            this.postal_code.length / 2,
            this.postal_code.length
          );
          this.postal_code = first_half + " " + second_half;
        }
        submit_button.innerHTML =
          '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ' +
          submit_button.innerHTML;

        let tracking_postal =
          this.tracking_id.trim().toUpperCase() +
          "+" +
          this.postal_code.toUpperCase();
        
        axios
          .get(parcel_api.concat('/query/')+tracking_postal)

          .then((res) => {
            this.displayData(res);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    closeModalErrorWindow() {
      let submit_button = document.querySelector(".submit_button");

      document.querySelector(".parcel_number").classList.remove("show");
      document.querySelector(".parcel_number").style.display = "none";
      document.querySelector(".parcel_number").ariaModal = false;
      document.querySelector(".parcel_number-value").innerHTML = "";

      submit_button.blur();
      submit_button.disabled = false;
      submit_button.innerHTML = "Submit";
    },
  },
  name: "track-your-shipment",
  components: {
    PageFooter,
    PageHeader,
  },
  data: function () {
    return {
      tracking_id: "",
      postal_code: "",
    };
  },
};
</script>
